import { AdvancedFilters } from "../types/filters";

export const buildParams = (
  filters: AdvancedFilters,
  userData: any,
  currency: string,
  page: number,
  order: string,
  orderBy: string,
  landscapeId: string,
  CBTType: string | null,
  currencyMode: string
) => ({
  UserID: userData?.UserID,
  userEmail: userData?.Email,
  LandscapeID: landscapeId,
  CBTType: CBTType || "",
  CountryCode: filters.country,
  CountryCodeName: filters.country,
  ReportingGroup: filters.rgFilter || "",
  CompanyCodes: Array.isArray(filters.companycodes)
    ? filters.companycodes.join(",")
    : filters.companycodes || "",
  BSReportingYear: filters.reportingyear,
  BSReportingMonth: filters.reportingmonth,
  BSComparisonYear: filters.comparisonyear,
  BSComparisonMonth: filters.comparisonmonth,
  PLReportingYear: filters.plreportingyear,
  PLReportingMonth: filters.plreportingmonth,
  PLComparisonYear: filters.plcomparisonyear,
  PLComparisonMonth: filters.plcomparisonmonth,
  PageType: userData.Role === "PREPARER" ? 1 : 2,
  CurrencyCode: currencyMode === "euro" ? "euro" : currency,
  ReviewScenarioID: filters.reviewscenario,
  SortByColumnKey: orderBy,
  SortOrder: order,
  PageNumber: page + 1,
  PerPageCount: 100,
});
